<script setup>
import {onBeforeMount, onMounted, onBeforeUnmount, ref, watch} from "vue";
import {useStore} from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
// import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

import bgProfile from "@/assets/img/bg-profile.webp";
// import bgProfile2 from "@/assets/img/bg-profile2.webp";
import {
  getPrintPhotoData,
  storePrintPhotoData,
  updatePrintPhotoData,
  getPrintPhotoOrder,
  getPrintPhotoOrders,
  deletePrintPhotoOrder,
  uploadPrintPhotoFile,
  getPrintPhotoFiles,
  updatePrintPhotoFile,
  deletePrintPhotoFile,
  calculatePrintPhotoPrice
} from "@/requests/user/order/PrintPhotoRequest.js";
import {
  getAddresses,
  // SetDefaultAddress,
  removeAddress,
  createAddress,
  updateAddress
} from "@/requests/user/profile/AddressRequest.js";
import {getProvinces, getCities} from "@/requests/user/provinces/ProvinceRequest.js";
import {toast} from "vue3-toastify";
// import router from "@/router";
import {useRouter, useRoute} from 'vue-router';

// Import Fancybox
import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const router = useRouter();
const route = useRoute();

const body = document.getElementsByTagName("body")[0];

const store = useStore();


// Ref for the Dropzone form element
// const dropzoneForm = ref(null);

// Dropzone instance
// let myDropzone = null;

// Upload progress tracking
const uploadProgress = ref({});

// Add file input ref
const fileInputRef = ref(null);

// Drag and drop state
const isDragging = ref(false);
const dragCounter = ref(0);

let priceCalcTimer = ref(null);
// let priceLoading = ref(false);

let orderFormData = ref({
  id: null,
  photo_size: null,
  print_type: null,
  lamination: null,
  chassis_type: null,
  frame: null,
  number: 1,//should remove
  description: null,
  address_id: null,
  totalPrice: 0,
  photos: {}
});


// Function to calculate price
const calculatePrice = async () => {
  if (!orderFormData.value.photo_size) {
    orderFormData.value.totalPrice = 0;
    // priceLoading.value = false;
    // return;
  }

  // priceLoading.value = true;

  const payload = {
    order_id: orderFormData.value.id,
    photo_size: orderFormData.value.photo_size,
    print_type: orderFormData.value.print_type,
    lamination: orderFormData.value.lamination,
    chassis_type: orderFormData.value.chassis_type,
    frame: orderFormData.value.frame
  };

  const resp = await calculatePrintPhotoPrice(payload);
  if (resp && resp.success) {
    orderFormData.value.totalPrice = resp.total_user ?? resp.total ?? 0;
  } else {
    orderFormData.value.totalPrice = 0;
  }

};


const orderForm = ref({
  action: 'create',//create,update
  loading: true,//create,update
  storeLoading: false,
  updateLoading: false,
  sizes: [],
  paper_types: [],
  laminates: [],
  chassis_types: [],
  frames: [],
  store: async function () {
    console.info('submitForm ', orderFormData.value)

    //update default address to this.data
    // orderFormData.value.address_id = addresses.value.items.find(addr => addr.is_default)?.id ?? null;
    // if(!orderFormData.value.address_id){
    //   toast.error('جهت ثبت سفارش ابتدا آدرس ارسال را انتخاب کنید');
    //   return;
    // }

    console.info('orderFormData ', orderFormData.value)

    orderForm.value.storeLoading = true;
    try {
      let response = await storePrintPhotoData(orderFormData.value);

      console.info('response ', response)

      if (response?.success && response?.data?.id) {

        // router.push({ query: { success: true, orderId: response.data.id } });

        orderForm.value.action = 'update';
        toast.success(response?.message ?? 'اطلاعات سفارش شما با موفقیت ثبت گردید!');

        toast.info('جهت تکمیل سفارش فایل های مربوطه را بارگذاری کنید');
        router.push({name: `order-print-photo-edit`, params: {id: response?.data?.id}});
        galleryModalShow.value = true;
        // Reload orders list
        await ordersList.value.loadOrders();
      } else {
        toast.error(response?.message ?? 'خطا در ثبت سفارش، دقایقی دیگر تلاش کنید.');
      }
    } finally {
      orderForm.value.storeLoading = false;
    }
  },
  update: async function () {
    //update default address to this.data
    // orderFormData.value.address_id = addresses.value.items.find(addr => addr.is_default)?.id ?? null;

    console.info('orderFormData update ', orderFormData.value)

    orderForm.value.updateLoading = true;
    try {
      let response = await updatePrintPhotoData(orderFormData.value.id, orderFormData.value);

      console.info('response ', response)
      if (response?.success) {
        toast.success(response?.message ?? 'اطلاعات سفارش شما با موفقیت بروزرسانی شد!');

        // Reload orders list
        await ordersList.value.loadOrders();
      } else {
        toast.error(response?.message ?? 'خطا در بروزرسانی سفارش، دقایقی دیگر تلاش کنید.');
      }
    } finally {
      orderForm.value.updateLoading = false;
    }
  },
  fillFormByData: function (data) {

    //sizes
    let sizesArray = [];
    data.sizes.forEach(size => {
      sizesArray.push({'id': size.id, 'text': size.label});
    });
    this.sizes = sizesArray;

    // Auto-select first size if in create mode and no size is currently selected
    if (this.action === 'create' && !orderFormData.value.photo_size && sizesArray.length > 0) {
      orderFormData.value.photo_size = sizesArray[0].id;
    }

    //paper types
    let paperTypesArray = [];
    data.paper_types.forEach(item => {
      paperTypesArray.push({'id': item.id, 'text': item.label});
    });
    this.paper_types = paperTypesArray;

    // Auto-select first paper type if in create mode and no paper type is currently selected
    if (this.action === 'create' && !orderFormData.value.print_type && paperTypesArray.length > 0) {
      orderFormData.value.print_type = paperTypesArray[0].id;
    }

    //laminates
    let laminatesArray = [];
    data.laminations.forEach(item => {
      laminatesArray.push({'id': item.id, 'text': item.label});
    });
    this.laminates = laminatesArray;

    // Auto-select first laminate if in create mode and no laminate is currently selected
    if (this.action === 'create' && !orderFormData.value.lamination && laminatesArray.length > 0) {
      orderFormData.value.lamination = laminatesArray[0].id;
    }


    //chassis_types
    let chassisTypesArray = [];
    data.chassis_types.forEach(item => {
      chassisTypesArray.push({'id': item.id, 'text': item.label});
    });
    this.chassis_types = chassisTypesArray;

    // Auto-select first chassis type if in create mode and no chassis type is currently selected
    if (this.action === 'create' && !orderFormData.value.chassis_type && chassisTypesArray.length > 0) {
      orderFormData.value.chassis_type = chassisTypesArray[0].id;
    }

    //frames
    let framesArray = [];
    data.frames.forEach(item => {
      framesArray.push({'id': item.id, 'text': item.label});
    });
    this.frames = framesArray;

    // Auto-select first frame if in create mode and no frame is currently selected
    if (this.action === 'create' && !orderFormData.value.frame && framesArray.length > 0) {
      orderFormData.value.frame = framesArray[0].id;
    }


    //disabled loading
    this.loading = false;
  },
  loadOrderData: async function (orderId) {
    try {
      const orderResponse = await getPrintPhotoOrder(orderId);
      console.info('orderResponse', orderResponse);
      if (orderResponse.success) {

        // Fill form with existing order data
        orderFormData.value = {
          id: orderResponse.data.id,
          photo_size: orderResponse.data.photo_size,
          print_type: orderResponse.data.print_type,
          lamination: orderResponse.data.lamination,
          chassis_type: orderResponse.data.chassis_type,
          frame: orderResponse.data.frame,
          number: orderResponse.data.number,
          description: orderResponse.data.description,
          address_id: orderResponse.data.deliver_address_id,
          photos: orderResponse.data.photos || {}
        };

        //set address
        addresses.value.loadAddresses();

        // Load photos for this order
        await photoUpload.value.loadPhotos(orderId);

        console.info('Order data loaded:', orderFormData.value);
      } else {
        toast.error(orderResponse.message || 'خطا در بارگذاری اطلاعات سفارش');
      }
    } catch (error) {
      console.error('Error loading order data:', error);
      toast.error('خطا در بارگذاری اطلاعات سفارش');
    }
  },

});

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();

  // console.info('route.params', route.params);
  orderFormData.value.id = route.params.id || null;
  if (orderFormData.value.id) {
    // Load existing order data
    orderForm.value.action = 'update';
    orderForm.value.loadOrderData(orderFormData.value.id);
  }

  // Initialize Fancybox
  setTimeout(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: ["slideshow", "thumbs", "close"],
        },
      },
      Thumbs: {
        showOnStart: true,
      },
      caption: (fancybox, slide) => {
        return slide.$caption ? slide.$caption.textContent || "" : "";
      },
    });
  }, 100);


});

// React to route id changes (e.g., navigating between orders)
watch(() => route.params.id, async (newId) => {
  if (newId) {
    orderForm.value.action = 'update';
    orderFormData.value.id = newId;
    await orderForm.value.loadOrderData(newId);
  } else {
    // back to create mode
    orderForm.value.action = 'create';
    orderFormData.value = {
      id: null,
      photo_size: null,
      print_type: null,
      lamination: null,
      chassis_type: null,
      frame: null,
      number: 1,
      description: null,
      address_id: null,
      photos: {}
    };

    //select first item for all selects
    if (orderForm.value.sizes.length > 0) {
      orderFormData.value.photo_size = orderForm.value.sizes[0].id;
    }
    if (orderForm.value.paper_types.length > 0) {
      orderFormData.value.print_type = orderForm.value.paper_types[0].id;
    }
    if (orderForm.value.laminates.length > 0) {
      orderFormData.value.lamination = orderForm.value.laminates[0].id;
    }
    if (orderForm.value.chassis_types.length > 0) {
      orderFormData.value.chassis_type = orderForm.value.chassis_types[0].id;
    }
    if (orderForm.value.frames.length > 0) {
      orderFormData.value.frame = orderForm.value.frames[0].id;
    }

  }
});

// watch(function(newPhotoSize){
//   console.info('%c Selected photo_size changed to: ' + newPhotoSize,'color:green;font-weight:bold;');
// })

/** listen for change any size laminate  type chassis type frame  file upload */
watch(orderFormData, () => {
  // console.info('%c orderFormData changed: ', 'color:blue;font-weight:bold;', newData);

  if (priceCalcTimer.value) {
    clearTimeout(priceCalcTimer.value);
  }

  priceCalcTimer.value = setTimeout(async () => {
    await calculatePrice();
  }, 300);
}, {deep: true});


//operation create or update address
let addresses = ref({
  type: 'create', // create, edit
  loading: true,
  data: {
    id: null,
    province_id: null,
    city_id: null,
    address: null,
    phone: null,
    is_default: false,
    is_selected: false,
  },
  items: [],
  provinces: [],
  cities: [],
  loadAddresses: async function () {
    try {
      this.loading = true;
      const response = await getAddresses();
      if (response?.success) {
        const addressesItems = [];
        (response.data || []).forEach((item) => {
          addressesItems.push({
            id: item.id,
            province: item.province,
            province_id: item.province_id,
            city: item.city,
            city_id: item.city_id,
            address: item.address,
            phone: item.phone,
            postal_code: item.postal_code,
            is_default: item.is_default,
            is_selected: false,
          });
        });
        this.items = addressesItems;

        //set default address to selected address on create
        if (this.items.length > 0 && orderForm.value.action == 'create' && !orderFormData.value.address_id) {
          this.items.find((item) => {
            if (item.is_default) {
              item.is_selected = true;
              orderFormData.value.address_id = item.id;
            }
          })
        }


        //set default address to selected address on update
        if (this.items.length > 0 && orderForm.value.action == 'update') {
          this.items.find((item) => {
            if (orderFormData.value.address_id == item.id) {
              item.is_selected = true;
            }
          })
        }

      } else {
        toast.error(response?.message || 'خطا در بارگذاری آدرس‌ها');
      }
    } catch (error) {
      toast.error('خطا در بارگذاری آدرس‌ها');
    } finally {
      this.loading = false;
    }
  },
  loadProvinces: async function () {
    try {
      const response = await getProvinces();
      if (response.success) {
        this.provinces = response.data.map(province => ({
          id: province.id,
          text: province.name
        }));
      } else {
        toast.error(response.message || 'خطا در بارگذاری استان‌ها');
      }
    } catch (error) {
      toast.error('خطا در بارگذاری استان‌ها');
    }
  },
  loadCities: async function (provinceId) {
    if (!provinceId) {
      this.cities = [];
      return;
    }
    try {
      console.log('Loading cities for province:', provinceId);
      const response = await getCities(provinceId);
      console.log('Cities response:', response);
      if (response.success) {
        this.cities = response.cities.map(city => ({
          id: city.id,
          text: city.name
        }));
        console.log('Cities loaded:', this.cities);
      } else {
        toast.error(response.message || 'خطا در بارگذاری شهرها');
      }
    } catch (error) {
      console.error('Error loading cities:', error);
      toast.error('خطا در بارگذاری شهرها');
    }
  },
  confirmDelete: function (id) {
    deleteConfirmAddressId.value = id;
    deleteConfirmAddressModalShow.value = true;
  },
  create: async function () {
    console.log('Creating address with data:', this.data);
    console.log('Creating address with data:', addresses.value);

    // Validate form
    if (!this.data.province_id || !this.data.city_id || !this.data.address) {
      toast.error('لطفاً تمام فیلدها را پر کنید');
      console.log('Validation failed:', {
        phone: this.data.phone,
        province_id: this.data.province_id,
        city_id: this.data.city_id,
        address: this.data.address
      });
      return;
    }

    this.loading = true;
    try {
      const addressData = {
        phone: this.data.phone,
        province_id: this.data.province_id,
        city_id: this.data.city_id,
        address: this.data.address
      };

      console.log('Sending address data:', addressData);
      const response = await createAddress(addressData);
      console.log('Address creation response:', response);

      if (response.success) {
        await this.loadAddresses();

        toast.success('آدرس با موفقیت ثبت شد');
        this.resetForm();
        addressActionModalShow.value = false;
      } else {
        toast.error(response.message || 'خطا در ثبت آدرس');
        console.error('Address creation failed:', response);
      }
    } catch (error) {
      console.error('Error creating address:', error);
      toast.error('خطا در ثبت آدرس');
    } finally {
      this.loading = false;
    }
  },
  edit: function (id) {
    this.type = 'edit';
    this.data.id = id;

    // Find and populate data from items
    const addressItem = this.items.find(item => item.id === id);
    if (addressItem) {
      this.data = {
        id: addressItem.id,
        province_id: addressItem.province_id,
        city_id: addressItem.city_id,
        address: addressItem.address,
        phone: addressItem.phone,
        is_default: addressItem.is_default
      };

      // Load cities for the selected province
      this.loadCities(addressItem.province_id);
    }

    addressActionModalShow.value = true;
    this.loading = false;
  },
  update: async function () {
    // Validate form
    if (!this.data.province_id || !this.data.city_id || !this.data.address) {
      toast.error('لطفاً تمام فیلدها را پر کنید');
      return;
    }

    this.loading = true;
    try {
      const response = await updateAddress(this.data.id, {
        province_id: this.data.province_id,
        city_id: this.data.city_id,
        address: this.data.address,
        phone: this.data.phone,
      });

      if (response.success) {
        await this.loadAddresses();
        toast.success('آدرس با موفقیت بروزرسانی شد');
        this.resetForm();
        addressActionModalShow.value = false;
      } else {
        toast.error(response.message || 'خطا در بروزرسانی آدرس');
      }
    } catch (error) {
      console.error('Error updating address:', error);
      toast.error('خطا در بروزرسانی آدرس');
    } finally {
      this.loading = false;
    }
  },
  delete: async function (id) {
    this.loading = true;
    try {
      console.info('remove ', id);
      const response = await removeAddress(id);
      if (!response.success) {
        toast.error(response.message);
        return;
      }
      await this.loadAddresses();
      toast.success(`آدرس با موفقیت حذف گردید`);
    } catch (error) {
      console.error('Error deleting address:', error);
      toast.error('خطا در حذف آدرس');
    } finally {
      this.loading = false;
      deleteConfirmAddressModalShow.value = false;
    }
  },
  changeDefault: async function (id) {
    console.info('change default ', id);
    // let response = await SetDefaultAddress(id);

    // if (!response.success) {
    //   toast.error(response.message);
    //   return;
    // }
    // await this.loadAddresses();
    this.items.map((item) => {
      item.is_selected = false;
    })

    this.items.find(item => item.id === id).is_selected = true;
    orderFormData.value.address_id = id;

    addressModalShow.value = false;
    // toast.success(`آدرس ارسال با موفقیت تغییر کرد و آدرس انتخاب شده به عنوان آدرس ارسال انتخاب شد`);
  },
  resetForm: function () {
    this.data = {
      id: null,
      province_id: null,
      city_id: null,
      address: null,
      is_default: false,
    };
    this.cities = [];
    this.type = 'create';
    this.loading = false;
  }
});

// Photo upload management
let photoUpload = ref({
  loading: false,
  items: [],
  totalCount: 0,
  totalPrintCount: 0,
  loadPhotos: async function (orderId) {
    if (!orderId) return;
    this.loading = true;
    try {
      const response = await getPrintPhotoFiles(orderId);
      if (response.success) {
        this.items = response.data || [];
        this.totalCount = this.items.reduce((sum) => sum + 1, 0);
        this.totalPrintCount = this.items.reduce((sum, photo) => sum + (photo.number || 1), 0);

        // Rebind Fancybox after loading photos
        setTimeout(() => {
          Fancybox.bind("[data-fancybox='gallery']", {
            Toolbar: {
              display: {
                left: ["infobar"],
                middle: [],
                right: ["slideshow", "thumbs", "close"],
              },
            },
            Thumbs: {
              showOnStart: true,
            },
            caption: (fancybox, slide) => {
              return slide.$caption ? slide.$caption.textContent || "" : "";
            },
          });
        }, 100);
      } else {
        toast.error(response.message || 'خطا در بارگذاری عکس‌ها');
      }
    } catch (error) {
      console.error('Error loading photos:', error);
      toast.error('خطا در بارگذاری عکس‌ها');
    } finally {
      this.loading = false;
    }
  },
  uploadPhoto: async function (orderId, file, number = 1) {
    if (!orderId) {
      toast.error('لطفاً ابتدا سفارش را ثبت کنید');
      return;
    }
    try {
      const response = await uploadPrintPhotoFile(orderId, file, number);
      if (response.success) {
        toast.success(response.message || 'عکس با موفقیت بارگذاری شد');
        await this.loadPhotos(orderId);
        return response.data;
      } else {
        toast.error(response.message || 'خطا در بارگذاری عکس');
        return null;
      }
    } catch (error) {
      console.error('Error uploading photo:', error);
      toast.error('خطا در بارگذاری عکس');
      return null;
    }
  },
  updateNumber: async function (photoId, newNumber) {
    try {
      const response = await updatePrintPhotoFile(photoId, {number: newNumber});
      if (response.success) {
        // Update price after number change

        toast.success('تعداد با موفقیت بروزرسانی شد');
        calculatePrice();

        // await this.loadPhotos(orderFormData.value.id);
      } else {
        toast.error(response.message || 'خطا در بروزرسانی تعداد');
      }
    } catch (error) {
      console.error('Error updating number:', error);
      toast.error('خطا در بروزرسانی تعداد');
    }
  },
  deletePhoto: async function (photoId, orderId) {
    try {
      const response = await deletePrintPhotoFile(photoId);
      if (response.success) {
        toast.success('عکس با موفقیت حذف شد');
        await this.loadPhotos(orderId);
        // Update price after deleting photo
        await calculatePrice();
      } else {
        toast.error(response.message || 'خطا در حذف عکس');
      }
    } catch (error) {
      console.error('Error deleting photo:', error);
      toast.error('خطا در حذف عکس');
    }
  }
});

// Orders list management
let ordersList = ref({
  loading: true,
  items: [],
  totalPrice: 0,
  selectedOrder: null,
  loadOrders: async function () {
    this.loading = true;
    try {
      const response = await getPrintPhotoOrders();
      if (response.success) {
      console.info('%c response :' ,'color:yellow;font-size:20px;',response.data);
        this.items = response.data.orders || response.data;
        this.totalPrice = response.data.total_price || 0;
      } else {
        toast.error(response.message || 'خطا در بارگذاری لیست سفارش‌ها');
      }
    } catch (error) {
      console.error('Error loading orders:', error);
      toast.error('خطا در بارگذاری لیست سفارش‌ها');
    } finally {
      this.loading = false;
    }
  },
  viewOrderDetails: function (orderId) {
    this.selectedOrder = this.items.find(order => order.id === orderId);
    viewOrderModalShow.value = true;
  },
  confirmEdit: function (orderId) {
    editConfirmOrderId.value = orderId;
    editConfirmModalShow.value = true;
  },
  confirmDelete: function (orderId) {
    deleteConfirmOrderId.value = orderId;
    deleteConfirmModalShow.value = true;
  },
  deleteOrder: async function (orderId) {
    try {
      const response = await deletePrintPhotoOrder(orderId);
      if (response.success) {
        this.items = this.items.filter(order => order.id !== orderId);
        toast.success(response.message || 'سفارش با موفقیت حذف شد');
        deleteConfirmModalShow.value = false;
      } else {
        toast.error(response.message || 'خطا در حذف سفارش');
      }
    } catch (error) {
      console.error('Error deleting order:', error);
      toast.error('خطا در حذف سفارش');
    }
  },
  editOrder: async function (orderId) {
    editConfirmModalShow.value = false;
    orderForm.value.action = 'update';
    orderFormData.value.id = orderId;
    await orderForm.value.loadOrderData(orderId);
    toast.info('اطلاعات سفارش بارگذاری شد');
  }
});


onBeforeMount(async () => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");

  store.state.isRTL = true;
  document.querySelector("html").setAttribute("lang", "fa");
  document.querySelector("html").setAttribute("dir", "rtl");
  document.querySelector("#app").classList.add("rtl");
  body.classList.remove("bg-gray-100");


  // user data from api and fill the form
  const printPhotoData = await getPrintPhotoData();

  console.info('printPhotoData ', printPhotoData)
  if (printPhotoData.success) {
    // orderForm.value.data = printPhotoData.data;
    // remove loading
    orderForm.value.fillFormByData(printPhotoData.data)
    // orderForm.value.loading = false;
  } else {
    toast.error(printPhotoData.message)
  }

  // load addresses via centralized method
  await addresses.value.loadAddresses();

  // Load orders list
  await ordersList.value.loadOrders();

  // Load provinces for address form
  await addresses.value.loadProvinces();

});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");

  // Destroy Fancybox instance
  Fancybox.destroy();
});

// const updateCities = async () => {
//   console.info('updateCities ', orderFormData.province);
//   //get cities by province id
//   // orderFormData.city = '';
//   let data = await getCities(orderFormData.province);
//   console.info('data ', data);
//   console.info('data.cities ', data.cities);
//   if (data.success) {
//     //populate city select
//
//     let citySelect = document.getElementById('city');
//     citySelect.innerHTML = '';
//
//     data.cities.forEach(city => {
//       let option = document.createElement('option');
//       option.value = city.id;
//       option.text = city.name;
//       citySelect.add(option);
//     });
//   }
// }


import 'select2/dist/css/select2.min.css';
import Select2 from 'vue3-select2-component';


// const myOptions = ref([
//   {id: '1', text: 'Option 1'},
//   {id: '2', text: 'Option 2'},
//   {id: '3', text: 'Option 3'},
// ]);


// const onChange = (val) => {
//   console.log('Changed:', val);
// };
//
// const onSelect = ({id, text}) => {
//   console.log('Selected:', {id, text});
// };

let galleryModalShow = ref(false);

const toggleGalleryModal = () => {
  console.info('toggle modal');
  galleryModalShow.value = !galleryModalShow.value;
}

// File upload handler
const handleFileSelect = (event) => {
  console.log('handleFileSelect called', event);
  const files = event.target.files;
  console.log('Files selected:', files);
  console.log('Number of files:', files ? files.length : 0);

  if (!files || files.length === 0) {
    console.log('No files selected');
    return;
  }

  // Upload each selected file
  for (let file of files) {
    console.log('Processing file:', file.name, file.type, file.size);
    uploadFile(file);
  }

  // Reset the input
  if (fileInputRef.value) {
    fileInputRef.value.value = '';
  }
};

const uploadFile = async (file) => {
  console.log('uploadFile called with file:', file);
  console.log('File instanceof File:', file instanceof File);
  console.log('File instanceof Blob:', file instanceof Blob);
  console.log('File details:', {
    name: file.name,
    type: file.type,
    size: file.size,
    constructor: file.constructor?.name
  });

  if (!orderFormData.value.id) {
    toast.error('لطفاً ابتدا سفارش را ثبت کنید');
    return;
  }

  // Track upload progress
  const fileName = file.name;
  uploadProgress.value[fileName] = {
    status: 'uploading',
    percent: 0,
    uploaded: 0,
    total: file.size,
    speed: 0,
    timeRemaining: 0
  };

  try {
    const response = await uploadPrintPhotoFile(
        orderFormData.value.id,
        file,
        1,
        (progress) => {
          // Update progress tracking
          uploadProgress.value[fileName] = {
            ...uploadProgress.value[fileName],
            percent: Math.round((progress.loaded / progress.total) * 100),
            uploaded: progress.loaded
          };
        }
    );

    if (response.success) {
      uploadProgress.value[fileName].status = 'completed';
      toast.success(`${fileName} با موفقیت آپلود شد`);

      // Reload photos
      await photoUpload.value.loadPhotos(orderFormData.value.id);

      // Update price after file upload
      await calculatePrice();

      // Remove from progress after 2 seconds
      setTimeout(() => {
        delete uploadProgress.value[fileName];
      }, 2000);
    } else {
      uploadProgress.value[fileName].status = 'failed';
      toast.error(`خطا در آپلود ${fileName}: ${response.message || 'خطای نامشخص'}`);

      // Remove from progress after 5 seconds
      setTimeout(() => {
        delete uploadProgress.value[fileName];
      }, 5000);
    }
  } catch (error) {
    uploadProgress.value[fileName].status = 'failed';
    toast.error(`خطا در آپلود ${fileName}`);
    console.error('Upload error:', error);

    // Remove from progress after 5 seconds
    setTimeout(() => {
      delete uploadProgress.value[fileName];
    }, 5000);
  }
};

const triggerFileInput = () => {
  if (fileInputRef.value) {
    fileInputRef.value.click();
  }
};

// Drag and drop handlers
const handleDragEnter = (e) => {
  e.preventDefault();
  dragCounter.value++;
  if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
    isDragging.value = true;
  }
};

const handleDragLeave = (e) => {
  e.preventDefault();
  dragCounter.value--;
  if (dragCounter.value === 0) {
    isDragging.value = false;
  }
};

const handleDragOver = (e) => {
  e.preventDefault();
};

const handleDrop = (e) => {
  e.preventDefault();
  isDragging.value = false;
  dragCounter.value = 0;

  const files = e.dataTransfer.files;
  if (files && files.length > 0) {
    // Process each file
    for (let file of files) {
      uploadFile(file);
    }
  }
};

const onChangeProvince = (val) => {
  console.log('on Changed Province :', val);
  console.log('Province id :', val.id);
  // Reset city when province changes
  addresses.value.data.city_id = null;
  // Load cities for selected province
  addresses.value.loadCities(val.id);
};

const onSelectProvince = (val) => {
  console.log('on Select Province:', val);
  console.log('Province id :', val.id);

  // Reset city when province changes
  addresses.value.data.city_id = null;
  // Load cities for selected province
  addresses.value.loadCities(val.id);
};


let addressActionModalShow = ref(false);

const toggleaddressesModal = () => {
  console.info('toggle modal');
  if (!addressActionModalShow.value) {
    // Opening modal - reset form for create mode
    addresses.value.resetForm();
    addresses.value.loading = false;
  }
  addressActionModalShow.value = !addressActionModalShow.value;
}


// Dropzone import and CSS
// import 'dropzone/dist/dropzone.css';  // Add this for styling
// import Dropzone from "dropzone";


let addressModalShow = ref(false);
let deleteConfirmAddressModalShow = ref(false);
let deleteConfirmAddressId = ref(null);

const toggleAddressModal = () => {
  console.info('toggle modal');
  addressModalShow.value = !addressModalShow.value;
}

// Modal refs for orders
let viewOrderModalShow = ref(false);
let editConfirmModalShow = ref(false);
let deleteConfirmModalShow = ref(false);
let editConfirmOrderId = ref(null);
let deleteConfirmOrderId = ref(null);

const toggleViewOrderModal = () => {
  viewOrderModalShow.value = !viewOrderModalShow.value;
}

const toggleEditConfirmModal = () => {
  editConfirmModalShow.value = !editConfirmModalShow.value;
}

const toggleDeleteConfirmModal = () => {
  deleteConfirmModalShow.value = !deleteConfirmModalShow.value;
}

</script>


<template>
  <main id="order-page" class="row">
    <div class="container-fluid col-12">
      <div
          class="page-header min-height-300"
          style="
          /*background-image: url(&quot;https://images.unsplash.com/photo-1531512073830-ba890ca4eba2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80&quot;);*/
          margin-right: -24px;
          margin-left: -34%;"
          :style="{backgroundImage:'url(' + bgProfile + ')' }"
      >
        <span class="mask bg-gradient-faded-dark opacity-8"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">


            <div class="mt-2 col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">
                  ثبت سفارش چاپ عکس
                </h5>
                <p class="mb-0 font-weight-bold text-sm">

                  جهت ثبت سفارش جزئیات فرم زیر را تکمیل کنید و عکس های مروبط به سفارش را بارگذاری کنید !
                </p>
              </div>
            </div>
            <!--                        <div class=" mt-3 col-lg-4 col-md-6 my-sm-auto me-sm-auto me-sm-0">-->
            <!--                          <div class="nav-wrapper position-relative end-0">-->
            <!--                            <ul-->
            <!--                                class="p-1 bg-transparent nav nav-pills nav-fill"-->
            <!--                                role="tablist"-->
            <!--                            >-->
            <!--                              <li class="nav-item">-->
            <!--                                <a-->
            <!--                                    class="px-0 py-1 mb-0 nav-link active"-->
            <!--                                    id="order-tab"-->
            <!--                                    data-bs-toggle="tab"-->
            <!--                                    data-bs-target="#order"-->
            <!--                                    href="javascript:;"-->
            <!--                                    role="tab"-->
            <!--                                    aria-selected="true"-->
            <!--                                >-->
            <!--                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"-->
            <!--                                       class="bi bi-file-earmark-fill" viewBox="0 0 16 16">-->
            <!--                                    <path-->
            <!--                                        d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2z"/>-->
            <!--                                  </svg>-->
            <!--                                  <span class="me-1">جزئیات سفارش</span>-->
            <!--                                </a>-->
            <!--                              </li>-->

            <!--                              <li class="nav-item">-->
            <!--                                <a-->
            <!--                                    class="px-0 py-1 mb-0 nav-link"-->
            <!--                                    data-bs-toggle="tab"-->
            <!--                                    data-bs-target="#galleries"-->

            <!--                                    href="javascript:;"-->
            <!--                                    role="tab"-->
            <!--                                    aria-selected="false"-->
            <!--                                >-->

            <!--                                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"-->
            <!--                                       class="bi bi-images" viewBox="0 0 16 16">-->
            <!--                                    <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>-->
            <!--                                    <path-->
            <!--                                        d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>-->
            <!--                                  </svg>-->

            <!--                                  <span class="me-1">عکس های سفارش</span>-->
            <!--                                </a>-->
            <!--                              </li>-->
            <!--                            </ul>-->
            <!--                          </div>-->
            <!--                        </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="tab-content py-4 container-fluid " :class="orderForm.action == 'update' ? 'col-md-12' : 'col-md-8' "
         id="myTabContent">

      <!--start::placeholder loading-->
      <div v-if="orderForm.loading" class="placeholder-glow row tab-pane  show active" role="tabpanel"
           aria-labelledby="order-tab">
        <div class="mt-2 ">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0 ms-auto placeholder" style="width: 100px; height: 15px"></p>
              </div>
            </div>
            <div class="card-body">

              <div class="row">

                <div class="mt-2 col-lg-4 ">
                  <div style="width: 100%; height: 30px;" class="rounded placeholder"></div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <div style="width: 100%; height: 30px;" class="rounded placeholder"></div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <div style="width: 100%; height: 30px;" class="rounded placeholder"></div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <div style="width: 100%; height: 30px;" class="rounded placeholder"></div>
                </div>

                <div class="mt-2 col-lg-4 ">
                  <div style="width: 100%; height: 30px;" class="rounded placeholder"></div>
                </div>

                <div class="mt-2 col-12">
                  <div style="width: 100%; height: 50px;" class="rounded placeholder"></div>
                </div>

                <hr class="horizontal dark mt-3"/>


                <div class="mt-2 col-md-6 py-3 hover-info my-auto">
                  <br>
                  <div style="width: 100%; height: 50px;" class="rounded placeholder"></div>
                </div>

                <div class="mt-2 col-md-6 py-3 my-auto hover-info">
                  <br>
                  <div style="width: 100%; height: 50px;" class="rounded placeholder"></div>
                </div>

              </div>
              <hr class="horizontal dark"/>

              <div class="row">
                <div style="width: 200px; height: 50px;" class="rounded placeholder"></div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--end::placeholder loading-->

      <div v-else class="row tab-pane  show active" id="order" role="tabpanel"
           aria-labelledby="order-tab">
        <div class="mt-2 ">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <!-- Create mode header -->
                <p v-if="orderForm.action !== 'update'" class="mb-0 ms-auto">
                  <span class="badge bg-success ms-2">ایجاد</span>
                  سفارش چاپ عکس
                </p>

                <!-- Edit mode header with different design -->
                <div v-else>
                  <router-link v-if="route.name !== 'order-print-photo-show' || route.name !== 'order-print-photo-edit'"
                               :to="{name:'order-print-photo-create'}">
                    <button class="btn btn-outline-primary">
                      <i class="fa fa-arrow-right ms-1"></i>
                      برگشت
                    </button>
                  </router-link>


                  <div class="ms-auto d-flex align-items-center px-3 py-2 rounded"
                       style="background: rgba(255,193,7,.12); border: 1px solid rgba(255,193,7,.35);">

                    <i class="fa fa-edit text-warning ms-1"></i>
                    <div class="ms-2">
                      <strong class="text-dark ">{{
                          route.name === 'order-print-photo-show' ? 'نمایش سفارش چاپ عکس' : 'ویرایش سفارش چاپ عکس'
                        }}

                        <small class="text-muted " v-if="orderFormData.id">شناسه #{{ orderFormData.id }}</small>

                      </strong>

                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="card-body">

              <div class="row">

                <div class="mt-2 col-lg-4 ">
                  <label for="size" class="form-control-label">سایز عکس </label>
                  <div>
                    <Select2
                        v-model="orderFormData.photo_size"
                        :options="orderForm.sizes"
                        :settings="{ placeholder: 'سایز چاپ عکس را انتخاب کنید', allowClear: true}"
                        dir="ltr"
                    />
                  </div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <label for="paper_type" class="form-control-label">نوع چاپ </label>
                  <div>
                    <Select2
                        v-model="orderFormData.print_type"
                        :options="orderForm.paper_types"
                        :settings="{ placeholder: 'نوع چاپ را انتخاب کنید', allowClear: true}"
                    />
                  </div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <label for="laminate" class="form-control-label">لمینت </label>
                  <div>
                    <Select2
                        v-model="orderFormData.lamination"
                        :options="orderForm.laminates"
                        :settings="{ placeholder: 'نوع لمینت را انتخاب کنید', allowClear: true}"
                    />
                  </div>
                </div>


                <div class="mt-2 col-lg-4 ">
                  <label for="chassis_type" class="form-control-label">نوع شاسی </label>
                  <div>
                    <Select2
                        v-model="orderFormData.chassis_type"
                        :options="orderForm.chassis_types"
                        :settings="{ placeholder: 'نوع شاسی را انتخاب کنید', allowClear: true}"
                    />
                  </div>
                </div>

                <div class="mt-2 col-lg-4 ">
                  <label for="frame" class="form-control-label">قاب </label>
                  <div>
                    <Select2
                        v-model="orderFormData.frame"
                        :options="orderForm.frames"
                        :settings="{ placeholder: 'نوع قاب را انتخاب کنید', allowClear: true}"
                    />
                  </div>
                </div>


                <div class="mt-2 col-12 mt-3">
                  <label for="description" class="form-control-label">توضیحات</label>
                  <textarea type="text" class="form-control" rows="1" v-model="orderFormData.description"
                            :readonly="route.name === 'order-print-photo-show'"></textarea>
                </div>

                <hr class="horizontal dark mt-3"/>


                <div class="mt-2 col-md-6 py-3 hover-info my-auto"
                     v-show="orderForm.action == 'update' && route.name !== 'order-print-photo-show'"
                     @click="toggleGalleryModal">
                  <label for="description" class="form-control-label">عکس های سفارش</label>
                  <br>
                  <span>
                    <i class="fa fa-images ms-2"></i>

                    <span>{{ photoUpload.items.length }}</span>
                    عکس 
                  </span>

                  <br>

                  <span>
                  <i class="fa fa-print ms-2"></i>

                    <span>{{ photoUpload.totalPrintCount }}</span>
                     چاپ
                  </span>

                </div>

                <div class="mt-2 col-md-6 py-3 my-auto hover-info" v-if="route.name !== 'order-print-photo-show'"
                     @click="toggleAddressModal">
                  <label for="description" class="form-control-label">ارسال به آدرس :</label>
                  <span v-if="addresses.items.filter(addr => addr.is_selected).length > 0"></span>
                  <span v-else>
                      <span class="text-warning">جهت انتخاب کلیک کنید!</span>
                    </span>

                  <br>
                  <div v-for="address in addresses.items.filter(addr => addr.is_selected)" :key="address.id">
                    <h5>
                      <i class="fa fa-edit ms-2"></i>
                      {{ address.province + '-' + address.city }}
                    </h5>
                    <span>آدرس : {{ address.address }}  </span>
                    <br>
                    <span>  تلفن تحویل گیرنده : {{ address.phone }}  </span>
                  </div>


                </div>

              </div>
              <hr class="horizontal dark"/>


              <div class="row">
                <h6 class="">
                  <i class="fa fa-coins ms-1"></i>
                  <span class="text-muted">جمع کل</span>
<!--                  <span v-if="priceLoading" class="text-info me-2">-->
<!--                      <i class="fa fa-spinner fa-spin ms-1"></i>-->
<!--                      در حال محاسبه...-->
<!--                    </span>-->
                   <span  class="text-success me-2">
                      {{ orderFormData.totalPrice ? orderFormData.totalPrice.toLocaleString('fa-IR') : '۰' }} تومان
                    </span>
                </h6>
              </div>

              <div class="row" v-if="route.name !== 'order-print-photo-show'">
                <argon-button v-if="orderForm.action == 'create'" @click="orderForm.store" color="success" size="sm"
                              class="w-md-30" type="submit" :disabled="orderForm.storeLoading">
                  <i v-if="orderForm.storeLoading" class="fa fa-spinner fa-spin ms-2"></i>
                  <i v-else class="fa fa-save ms-2"></i>
                  <span v-if="orderForm.storeLoading">در حال ثبت...</span>
                  <span v-else>ثبت سفارش</span>
                </argon-button>

                <argon-button v-else color="warning" @click="orderForm.update" size="sm" class="w-md-20" type="submit"
                              :disabled="orderForm.updateLoading">
                  <i v-if="orderForm.updateLoading" class="fa fa-spinner fa-spin ms-2"></i>
                  <i v-else class="fa fa-sync ms-2"></i>
                  <span v-if="orderForm.updateLoading">در حال بروزرسانی...</span>
                  <span v-else>بروزرسانی سفارش</span>
                </argon-button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Orders List Section (Left Side) -->
    <div v-if="orderForm.action !== 'update'" class="py-4 container-fluid col-md-4">
      <div class="mt-2">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <h6 class="mb-0">
                لیست سفارش‌های شما
                <span v-if="!ordersList.loading" class="badge bg-primary ms-2">{{ ordersList.items.length }}</span>
                <span v-else class="placeholder col-2 ms-2" style="height: 1em;"></span>
              </h6>
              <div class="text-end" v-if="!ordersList.loading">
                <p class="text-xs mb-0 text-muted">جمع کل</p>
                <h6 class="mb-0 text-success">
                  <i class="fa fa-coins ms-1"></i>
                  {{ ordersList.totalPrice ? ordersList.totalPrice.toLocaleString('fa-IR') : '۰' }} تومان
                </h6>
              </div>
              <div v-else class="text-end placeholder-glow">
                <span class="placeholder" style="width: 80px; height: 20px;"></span>
              </div>
            </div>
          </div>
          <div class="card-body" style="max-height: 700px; overflow-y: auto;">

            <!-- Loading Placeholder -->
            <div v-if="ordersList.loading" class="placeholder-glow">
              <div v-for="i in 3" :key="i" class="card mb-3">
                <div class="card-body">
                  <span class="placeholder col-7"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-4"></span>
                  <span class="placeholder col-6"></span>
                </div>
              </div>
            </div>

            <!-- Orders List -->
            <div v-else>
              <div v-if="ordersList.items.length === 0" class="text-center py-4">
                <i class="fa fa-inbox fa-3x text-secondary mb-3"></i>
                <p class="text-secondary">هیچ سفارشی ثبت نشده است</p>
              </div>

              <div v-else v-for="order in ordersList.items" :key="order.id" class="card mb-3 hover-shadow">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h6 class="mb-1">{{ order.title }}</h6>
                      <small class="text-muted">شناسه: #{{ order.id }}</small>
                    </div>
                    <span class="badge bg-gradient-faded-dark">{{ order.status_label || 'در حال بررسی' }}</span>
                  </div>

                  <div class="row mb-2">
                    <p class="col-md-4 mb-1 text-sm">
                      <i class="fa fa-image ms-1"></i>
                      <strong>{{ order.photos_count || 0 }}</strong> عکس
                    </p>
                    <p class="col-md-8 text-start mb-0 text-sm text-success">
                      <i class="fa fa-money-bill ms-1"></i>
                      <strong>{{ order.total_price ? order.total_price.toLocaleString('fa-IR') : '۰' }}</strong> تومان
                    </p>
                  </div>

                  <hr class="horizontal dark my-2"/>

                  <div class="d-flex ">
                    <router-link :to="{name:'order-print-photo-show',params:{'id':order.id}}">
                      <button
                          class="btn text-primary mb-0 px-2 py-1 ms-2" title="مشاهده جزئیات">
                        <i class="fa fa-eye"></i>
                      </button>
                    </router-link>

                    <router-link :to="{name:'order-print-photo-edit',params:{'id':order.id}}">
                      <button class="btn text-warning mb-0 px-2 py-1 ms-2" title="ویرایش">
                        <i class="fa fa-edit"></i>
                      </button>
                    </router-link>
                    <button @click="ordersList.confirmDelete(order.id)"
                            class="btn text-danger mb-0 px-2 py-1 ms-2" title="حذف">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </main>

  <div>


    <!-- The gallery modal -->
    <div class="modal show" id="galleryModalShow" v-bind:style="{ display: galleryModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">عکس های سفارش</h1>
            <button type="button" class="btn mb-0 px-2 btn-outline-danger pt-1 pb-2 " @click="toggleGalleryModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-octagon"
                   viewBox="0 0 16 16">
                <path
                    d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <!-- Hidden file input -->
            <input
                ref="fileInputRef"
                type="file"
                accept="image/*,.pdf"
                multiple
                style="display: none;"
                @change="handleFileSelect"
                :disabled="!orderFormData.id"
            />

            <!-- Modern Drag & Drop Upload Area -->
            <div v-if="orderFormData.id" class="upload-section">
              <div
                  class="drag-drop-zone"
                  :class="{ 'drag-over': isDragging }"
                  @dragenter="handleDragEnter"
                  @dragover="handleDragOver"
                  @dragleave="handleDragLeave"
                  @drop="handleDrop"
                  @click="triggerFileInput"
              >
                <div class="upload-content">

                  <h6 class="upload-title">
                    فایل‌ها را اینجا بکشید و رها کنید
                  </h6>
                  <p class="upload-subtitle">
                    یا کلیک کنید تا فایل‌ها را انتخاب کنید
                  </p>
                  <div class="upload-formats">
                    <span class="format-badge">
                      <i class="fa fa-file-image ms-1"></i>
                      JPG
                    </span>
                    <span class="format-badge">
                      <i class="fa fa-image ms-1"></i>
                      PNG
                    </span>
                    <span class="format-badge">
                      <i class="fa fa-file ms-1"></i>
                      WEBP
                    </span>
                  </div>
                  <p class="upload-note">
                    <i class="fa fa-info-circle ms-1"></i>
                    حداکثر حجم فایل: 10MB
                  </p>
                </div>
              </div>
            </div>

            <!-- Message when no order ID exists -->
            <div v-if="!orderFormData.id" class="alert alert-warning">
              <i class="fa fa-exclamation-triangle ms-2"></i>
              لطفاً ابتدا سفارش را ثبت کنید
            </div>

            <!-- Header showing total count -->
            <div v-if="orderFormData.id && photoUpload.items.length > 0" class="row mb-3 p-2 bg-light rounded">
              <h6 class="mb-0 col-md-6">
                <i class="fa fa-images ms-2 text-primary"></i>
                تعداد فایل ها: {{ photoUpload.totalCount }}
              </h6>

              <h6 class="mb-0 col-md-6">
                <i class="fa fa-print ms-2 text-primary"></i>
                تعداد چاپ: {{ photoUpload.totalPrintCount }} فایل
              </h6>
            </div>

            <!-- Loading state -->
            <div v-if="photoUpload.loading" class="placeholder-glow">
              <div class="card mb-2">
                <div class="card-body">
                  <div class="row">
                    <div class="mt-2 col-2">
                      <span class="placeholder rounded" style="width: 50px; height: 50px"></span>
                    </div>
                    <div class="mt-2 col-8 d-flex">
                      <span class="placeholder rounded" style="width: 100%;"></span>
                    </div>
                    <div class="mt-2 col-2 my-auto">
                      <span class="placeholder rounded" style="width: 50px; height: 50px"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div v-if="!photoUpload.loading && photoUpload.items.length === 0 && orderFormData.id"
                 class="text-center py-4">
              <i class="fa fa-cloud-upload fa-4x text-secondary mb-3"></i>
              <p class="text-muted">هنوز عکسی آپلود نشده است</p>
            </div>

            <!-- Upload Progress Indicators -->
            <div v-if="Object.keys(uploadProgress).length > 0">
              <div v-for="(progress, fileName) in uploadProgress" :key="fileName" class="card mb-2">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col-12 mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <span class="fw-bold">{{ fileName }}</span>
                        <span v-if="progress.status === 'uploading'" class="badge bg-info">
                          <i class="fa fa-spinner fa-spin ms-1"></i>
                          در حال آپلود...
                        </span>
                        <span v-else-if="progress.status === 'completed'" class="badge bg-success">
                          <i class="fa fa-check ms-1"></i>
                          تکمیل شد
                        </span>
                        <span v-else-if="progress.status === 'failed'" class="badge bg-danger">
                          <i class="fa fa-times ms-1"></i>
                          خطا در آپلود
                        </span>
                      </div>
                    </div>

                    <div v-if="progress.status === 'uploading'" class="col-12">
                      <div class="progress" style="height: 20px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated"
                             :style="{ width: progress.percent + '%' }"
                             role="progressbar">
                          {{ progress.percent }}%
                        </div>
                      </div>
                      <div class="d-flex justify-content-between mt-1">
                        <small class="text-muted">
                          {{ (progress.uploaded / 1024).toFixed(2) }} KB / {{ (progress.total / 1024).toFixed(2) }} KB
                        </small>
                        <small class="text-muted" v-if="progress.speed > 0">
                          سرعت: {{ progress.speed }} KB/s |
                          <span v-if="progress.timeRemaining > 0">زمان باقیمانده: {{
                              progress.timeRemaining
                            }}ثانیه</span>
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Uploaded photos list -->
            <div v-if="!photoUpload.loading && photoUpload.items.length > 0">
              <div v-for="photo in photoUpload.items" :key="photo.id" class="card mb-2">
                <div class="card-body pb-0 pt-3">
                  <div class="row align-items-center">
                    <div class="col-1 px-0">
                      <button
                          class="btn btn-sm btn-outline-danger px-2 mb-0"
                          @click="photoUpload.deletePhoto(photo.id, orderFormData.id)">
                        <i class="fa fa-trash-alt"></i>
                      </button>

                    </div>
                    <div class="col-2 position-relative">
                      <a
                          :href="photo.url || photo.path"
                          data-fancybox="gallery"
                          :data-caption="photo.name || 'عکس'"
                          class="fancybox-link"
                          style="display: block; cursor: pointer; position: relative;">
                        <!-- نمایش تامبنیل اگر وجود دارد، در غیر این صورت فایل اصلی -->
                        <img :src="photo.thumbnail_url || photo.url || photo.path"
                             class="img-fluid rounded"
                             style="max-height: 80px; object-fit: cover; width: 100%;"
                             :alt="photo.name || 'عکس'">
                        <div class="image-overlay">
                          <i class="fa fa-search-plus"></i>
                        </div>
                      </a>

                    </div>

                    <div class="col-6">
                      <p class="mb-1 fw-bold">{{ photo.name || 'فایل' }}</p>
                      <small class="text-muted">
                        <i class="fa fa-file ms-1"></i>
                        {{ photo.size ? (photo.size / 1024).toFixed(2) + ' KB' : '' }}
                      </small>
                    </div>

                    <div class="col-2">
                      <div class="d-flex align-items-end">
                        <label class="text-sm my-auto me-1">تعداد</label>
                        <input type="number"
                               class="form-control form-control-sm text-center"
                               :value="photo.number || 1"
                               @change="photoUpload.updateNumber(photo.id, $event.target.value)"
                               min="1"
                               style="width: 70px;">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <!-- The address modal -->
    <div class="modal show" id="addressModalShow" v-bind:style="{ display: addressModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">لیست آدرس ها
              <button class="btn btn-sm  fa fa-plus btn-success px-2" @click="toggleaddressesModal">افزودن</button>
            </h1>
            <button type="button" class="btn mb-0 px-2 btn-outline-danger pt-1 pb-2 " @click="toggleAddressModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-octagon"
                   viewBox="0 0 16 16">
                <path
                    d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <!-- Example of a form that Dropzone can take over -->

            <!-- start::already uploaded images-->
            <div class="card mb-2" v-show="addresses.items.length > 0" v-for="address in addresses.items"
                 :key="address.id">
              <div class="card-body">
                <div class="row position-absolute start-0">
                  <div class="mt-2 col-5 my-auto d-flex justify-content-between">
                    <button class="btn d-flex ms-1 my-auto px-2 py-1 shadow-none text-info "
                            @click="addresses.edit(address.id)">
                      <i class="fa fa-edit position-relative top-2px ps-1"></i>
                      <small class="">ویرایش</small>
                    </button>

                    <button class="btn d-flex my-auto px-2 py-1 shadow-none text-danger "
                            @click="addresses.confirmDelete(address.id)">
                      <i class="fa fa-trash-alt position-relative top-2px ps-1"></i>
                      <small>حذف</small>
                    </button>
                  </div>
                </div>

                <div class="row" @click="addresses.changeDefault(address.id)">
                  <div class="mt-2 col-12 d-flex">
                    <input
                        type="radio"
                        name="default-address"
                        :value="address.id"
                        :id="address.id"
                        :checked="address.is_selected"
                        class="ms-1"

                    />
                    <label class="h5" :for="address.id">{{ address.province }} {{ address.city }}</label>
                  </div>
                  <div class="mt-2 col-12">
                    <p>آدرس : {{ address.address }}</p>
                    <p>تلفن تحویل گیرنده : {{ address.phone }}</p>
                  </div>
                </div>

              </div>
            </div>
            <!-- end::already uploaded images -->

            <!-- start::placeholders -->
            <div class="card mb-2" v-show="addresses.items.length <= 0">
              <div class="card-body placeholder-glow">
                <div class="row">
                  <div class="mt-2 col-12">
                    <span class="placeholder rounded ms-1" style="width: 100px; height: 30px"></span>
                  </div>
                  <div class="mt-2 col-12 mt-2">
                    <p class="placeholder rounded"></p>
                  </div>
                </div>
              </div>
            </div>
            <!-- end::placeholders -->

          </div>

        </div>
      </div>
    </div>

    <!-- Delete Address Confirmation Modal -->
    <div class="modal show" id="deleteConfirmAddressModalShow"
         v-bind:style="{ display: deleteConfirmAddressModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-gradient-danger">
            <h5 class="modal-title text-white w-100">تأیید حذف آدرس</h5>
            <button type="button" class="btn-close" @click="deleteConfirmAddressModalShow = false"></button>
          </div>
          <div class="modal-body text-center py-4">
            <i class="fa fa-exclamation-triangle fa-3x text-danger mb-3"></i>
            <h6>آیا از حذف این آدرس اطمینان دارید؟</h6>
            <p class="text-sm text-muted">این عملیات قابل بازگشت نیست!</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="deleteConfirmAddressModalShow = false">انصراف
            </button>
            <button type="button" class="btn btn-danger" @click="addresses.delete(deleteConfirmAddressId)">
              <i class="fa fa-trash ms-1"></i>
              بله، حذف شود
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- The create/update address  modal -->
    <div class="modal show" id="addressActionModalShow"
         v-bind:style="{ display: addressActionModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5 cursor-pointer text-warning" id="exampleModalLabel"
                @click="toggleaddressesModal">
              <i class="fa fa-arrow-right ms-2"></i>
              افزودن/ویرایش آدرس
            </h1>
            <button type="button" class="btn mb-0 px-2 btn-outline-danger pt-1 pb-2 " @click="toggleaddressesModal">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-octagon"
                   viewBox="0 0 16 16">
                <path
                    d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
                <path
                    d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <!-- Example of a form that Dropzone can take over -->

            <!-- start::already uploaded images-->
            <div class="card mb-2" v-if="!addresses.loading">
              <div class="card-body">
                <div class="row">
                  <div class="mt-2 col-6 ">
                    <label class="h5" for="address1">استان</label>

                    <Select2
                        v-model="addresses.data.province_id"
                        :options="addresses.provinces"
                        :settings="{ placeholder: 'استان را انتخاب کنید', allowClear: true, dropdownParent: '#addressActionModalShow' }"
                        @change="onChangeProvince($event)"
                        @select="onSelectProvince($event)"
                    />
                  </div>
                  <div class="mt-2 col-6 ">
                    <label class="h5" for="address1">شهر</label>

                    <div class="w-100">
                      <Select2
                          v-model="addresses.data.city_id"
                          :options="addresses.cities"
                          :settings="{ placeholder: 'شهر را انتخاب کنید', allowClear: true, dropdownParent: '#addressActionModalShow' }"
                      />
                    </div>
                  </div>
                  <div class="mt-2 col-12 ">
                    <label class="h5" for="address">آدرس</label>
                    <textarea type="text" class="form-control" id="address" rows="2"
                              v-model="addresses.data.address"></textarea>
                  </div>

                  <div class="mt-2 col-12 ">
                    <label class="h5" for="phone">شماره تماس</label>
                    <input type="text" inputmode="numeric" class="form-control" id="phone"
                           v-model="addresses.data.phone"/>
                  </div>

                </div>
              </div>
            </div>
            <!-- end::already uploaded images -->


            <!-- start::placeholders -->
            <div class="card mb-2" v-else>
              <div class="card-body placeholder-glow">
                <div class="row">
                  <div class="mt-2 col-6">
                    <span class="placeholder rounded ms-1" style="width: 100%; height: 30px"></span>
                  </div>
                  <div class="mt-2 col-6">
                    <span class="placeholder rounded ms-1" style="width: 100%; height: 30px"></span>
                  </div>
                  <div class="mt-2 col-12 mt-3">
                    <p class="placeholder rounded" style="width: 100%; height: 60px"></p>
                  </div>
                </div>
                <div class="mt-2 col-12 mt-3">
                  <p class="placeholder rounded" style="width: 100%; height: 60px"></p>
                </div>
              </div>
            </div>

            <!-- end::placeholders -->

          </div>
          <div class="modal-footer">

            <button v-show="addresses.type == 'create'" @click="addresses.create()" class="btn btn-success"
                    :disabled="addresses.loading">
              <span v-if="addresses.loading">در حال ثبت...</span>
              <span v-else>ثبت آدرس</span>
            </button>
            <button v-show="addresses.type == 'edit'" @click="addresses.update()" class="btn btn-warning"
                    :disabled="addresses.loading">
              <span v-if="addresses.loading">در حال بروزرسانی...</span>
              <span v-else>بروزرسانی آدرس</span>
            </button>
          </div>

        </div>
      </div>
    </div>


    <!-- Delete Confirmation Modal -->
    <div class="modal show" id="deleteConfirmModalShow"
         v-bind:style="{ display: deleteConfirmModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-gradient-danger">
            <h5 class="modal-title text-white w-100">تأیید حذف سفارش</h5>
            <button type="button" class="btn-close" @click="toggleDeleteConfirmModal"></button>
          </div>
          <div class="modal-body text-center py-4">
            <i class="fa fa-exclamation-triangle fa-3x text-danger mb-3"></i>
            <h6>آیا از حذف این سفارش اطمینان دارید؟</h6>
            <p class="text-sm text-muted">این عملیات قابل بازگشت نیست!</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="toggleDeleteConfirmModal">انصراف</button>
            <button type="button" class="btn btn-danger" @click="ordersList.deleteOrder(deleteConfirmOrderId)">
              <i class="fa fa-trash ms-1"></i>
              بله، حذف شود
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Confirmation Modal -->
    <div class="modal show" id="editConfirmModalShow"
         v-bind:style="{ display: editConfirmModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-gradient-warning">
            <h5 class="modal-title text-white w-100">تأیید ویرایش سفارش</h5>
            <button type="button" class="btn-close" @click="toggleEditConfirmModal"></button>
          </div>
          <div class="modal-body text-center py-4">
            <i class="fa fa-exclamation-circle fa-3x text-warning mb-3"></i>
            <h6>توجه: اطلاعات فرم فعلی پاک خواهد شد</h6>
            <p class="text-sm text-muted">با ویرایش این سفارش، تمام اطلاعات وارد شده در فرم سمت راست پاک شده و اطلاعات
              سفارش انتخابی جایگزین می‌شود. آیا مطمئن هستید؟</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="toggleEditConfirmModal">انصراف</button>
            <button type="button" class="btn btn-warning" @click="ordersList.editOrder(editConfirmOrderId)">
              <i class="fa fa-edit ms-1"></i>
              بله، ویرایش شود
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- View Order Details Modal -->
    <div class="modal show" id="viewOrderModalShow"
         v-bind:style="{ display: viewOrderModalShow ? 'block' : 'none' }"
         tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header bg-gradient-primary">
            <h5 class="modal-title text-white w-100">جزئیات سفارش</h5>
            <button type="button" class="btn-close" @click="toggleViewOrderModal"></button>
          </div>
          <div class="modal-body" v-if="ordersList.selectedOrder">
            <div class="row">
              <!-- Order Info -->
              <div class="col-12 mb-3">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>اطلاعات سفارش</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>شناسه سفارش:</strong></p>
                        <p class="text-secondary">#{{ ordersList.selectedOrder.id }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>وضعیت:</strong></p>
                        <span class="badge bg-gradient-info">{{
                            ordersList.selectedOrder.status_label || 'در حال بررسی'
                          }}</span>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>سایز عکس:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.size || '-' }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>نوع چاپ:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.print_type_label || '-' }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>لمینت:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.lamination_label || '-' }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>نوع شاسی:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.chassis_type_label || '-' }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>قاب:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.frame_label || '-' }}</p>
                      </div>
                      <div class="col-md-4 mb-2">
                        <p class="text-sm mb-1"><strong>قیمت کل:</strong></p>
                        <p class="text-success"><strong>{{
                            ordersList.selectedOrder.price ? ordersList.selectedOrder.price.toLocaleString('fa-IR') : '۰'
                          }}</strong> تومان</p>
                      </div>
                      <div class="col-12 mb-2" v-if="ordersList.selectedOrder.description">
                        <p class="text-sm mb-1"><strong>توضیحات:</strong></p>
                        <p class="text-secondary">{{ ordersList.selectedOrder.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Address Info -->
              <div class="col-12 mb-3" v-if="ordersList.selectedOrder.address">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>آدرس ارسال</h6>
                  </div>
                  <div class="card-body">
                    <p class="text-sm mb-1"><strong>{{ ordersList.selectedOrder.address.province }} -
                      {{ ordersList.selectedOrder.address.city }}</strong></p>
                    <p class="text-secondary">{{ ordersList.selectedOrder.address.address }}</p>
                    <p class="text-sm text-muted" v-if="ordersList.selectedOrder.address.phone">
                      <i class="fa fa-phone ms-1"></i>
                      {{ ordersList.selectedOrder.address.phone }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Photos Info -->
              <div class="col-12">
                <div class="card">
                  <div class="card-header pb-0">
                    <h6>عکس‌های سفارش</h6>
                  </div>
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="mb-1">
                          <i class="fa fa-images fa-2x text-primary"></i>
                        </p>
                        <p class="text-sm mb-0">
                          <strong>{{ ordersList.selectedOrder.photos_count || 0 }}</strong> عکس
                        </p>
                      </div>
                      <div class="text-end">
                        <p class="text-sm mb-1">تعداد کل فایل‌ها جهت چاپ:</p>
                        <p class="text-primary mb-0"><strong>{{ ordersList.selectedOrder.total_prints || 0 }}</strong>
                          فایل</p>
                      </div>
                    </div>

                    <!-- Photos Gallery (if available) -->
                    <div class="row mt-3"
                         v-if="ordersList.selectedOrder.photos && ordersList.selectedOrder.photos.length > 0">
                      <div v-for="photo in ordersList.selectedOrder.photos" :key="photo.id" class="col-4 mb-2">
                        <img :src="photo.url" class="img-fluid rounded" :alt="photo.name">
                        <p class="text-xs text-center mt-1">تعداد: {{ photo.number }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="toggleViewOrderModal">بستن</button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<style scoped>
.hover-shadow {
  transition: all 0.3s ease;
  cursor: pointer;
}

.hover-shadow:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.hover-info {
  cursor: pointer;
  transition: all 0.2s ease;
}

.hover-info:hover {
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
}

/* Modern Drag & Drop Upload Styles */
.upload-section {
  margin-bottom: 2rem;
}

.drag-drop-zone {
  position: relative;
  border: 3px dashed #cbd5e0;
  border-radius: 16px;
  padding: 1rem;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  overflow: hidden;
}

.drag-drop-zone::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.05) 0%, rgba(139, 92, 246, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.drag-drop-zone:hover {
  border-color: #3b82f6;
  background: linear-gradient(135deg, #ecf0f3 0%, #f8f9fa 100%);
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.1);
}

.drag-drop-zone:hover::before {
  opacity: 1;
}

.drag-drop-zone.drag-over {
  border-color: #10b981;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  transform: scale(1.02);
  box-shadow: 0 15px 35px rgba(16, 185, 129, 0.2);
  animation: pulse-border 1.5s ease-in-out infinite;
}

.drag-drop-zone.drag-over .upload-icon {
  animation: bounce 0.6s ease-in-out infinite;
}

.drag-drop-zone.drag-over::before {
  opacity: 0.3;
  background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%);
}

@keyframes pulse-border {
  0%, 100% {
    border-color: #10b981;
  }
  50% {
    border-color: #34d399;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.upload-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.upload-icon {
  font-size: 4rem;
  color: #3b82f6;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
}

.drag-drop-zone:hover .upload-icon {
  color: #2563eb;
  transform: scale(1.1);
}

.upload-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.upload-subtitle {
  font-size: 0.95rem;
  color: #64748b;
  margin-bottom: 1.5rem;
}

.upload-formats {
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.format-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.format-badge:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.15);
}

.format-badge i {
  font-size: 1rem;
  color: #3b82f6;
}

.upload-note {
  font-size: 0.875rem;
  color: #94a3b8;
  margin: 1rem 0 0 0;
}

.upload-note i {
  color: #6366f1;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .drag-drop-zone {
    padding: 2rem 1rem;
  }

  .upload-icon {
    font-size: 3rem;
  }

  .upload-title {
    font-size: 1.1rem;
  }

  .upload-subtitle {
    font-size: 0.85rem;
  }

  .format-badge {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
  }
}

/* Fancybox Image Overlay Styles */
.fancybox-link {
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
  border-radius: 8px;
}

.fancybox-link:hover {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
}

.fancybox-link:hover .image-overlay {
  opacity: 1;
}

.image-overlay i {
  font-size: 2rem;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}
</style>
